import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Image, Container } from "react-bootstrap";
import {
  Form,
  Modal,
  Button,
  Icon,
  Message,
  Segment,
  Dropdown,
} from "semantic-ui-react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Calendar } from "react-date-range";
import defImage from "../../../assets/images/image.png";
import axios from "axios";

function StudentForm({ showModal, setShowModal, setCreated, school }) {
  const [newStudent, setStudent] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    address: "",
    image: "",
    imageUrl: "",
    level: "",
  });
  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    dob: false,
    address: false,
    image: false,
    level: false,
    response: { show: false, type: "success", message: "" },
  });
  const [loadImage, setLoadImage] = useState(false);
  const [loading, setLoading] = useState(false);
  const uploader = useRef(null);
  const [showCal, setShowCal] = useState(false);

  useEffect(() => {
    return () => {
      setStudent({ ...newStudent, image: "" });
      setCreated(false);
    };
  }, []);

  const options = [...Array(school.levels).keys()].map((level, index) => {
    return {
      key: level.uuid,
      text: level + 1,
      value: level + 1,
    };
  });

  const showPicker = () => {
    uploader.current.click();
  };

  const handlePickImage = async (event) => {
    const file = event.target.files[0];
    console.log(file);
    setLoadImage(true);
    const formData = new FormData();
    formData.append("file", file);

    formData.append("upload_preset", "roll_app");

    const options = {
      method: "POST",
      body: formData,
    };

    setStudent({
      ...newStudent,
      image: URL.createObjectURL(file),
    });

    const results = await fetch(
      `${process.env.REACT_APP_CLOUDINARY_API}/image/upload`,
      options
    );
    const response = await results.json();

    setStudent({
      ...newStudent,
      image: URL.createObjectURL(file),
      imageUrl: response ? response.secure_url : file,
    });
    setLoadImage(false);
  };

  const handleDate = (date) => {
    setStudent({
      ...newStudent,
      dob: date,
    });
    setShowCal(false);
  };

  const handleAddStudent = async () => {
    try {
      if (!newStudent.firstName.trim())
        return setErrors({ ...errors, firstName: true });

      if (!newStudent.lastName.trim())
        return setErrors({ ...errors, lastName: true });

      if (!newStudent.dob) return setErrors({ ...errors, dob: true });
      setLoading(true);

      if (!newStudent.address) return setErrors({ ...errors, address: true });
      if (!newStudent.level) return setErrors({ ...errors, level: true });

      setLoading(true);
      const { firstName, lastName, address, dob, imageUrl, level } = newStudent;
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/students/${school.uuid}/${level}`,
        {
          firstName,
          lastName,
          address,
          dob,
          image: imageUrl,
        },
        { headers: { token: localStorage.getItem("token") } }
      );
      setLoading(false);
      console.log(response);
      if (response.status === 201) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "success",
            message: "Student successfully created!",
          },
        });
        setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
        setShowModal(false);
        setCreated(true);
        return;
      }
      return;
    } catch (error) {
      console.log("error.message", error);
      setLoading(false);
      if (error?.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 400) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 401) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 409) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  return (
    <Modal
      open={showModal}
      centered
      dimmer="blurring"
      size="tiny"
      style={{
        position: "relative",
        height: "87vh",
      }}
      closeOnEscape
    >
      <Container
        fluid
        className="d-flex justify-content-center p-5 align-items-center"
      >
        <Row>
          <Col>
            <Modal.Content>
              <Modal.Header
                className="d-flex justify-content-center"
                content="Add New Student"
                as="h2"
              />
              <Container>
                <Row>
                  <Col>
                    <Image
                      src={!newStudent.image ? `${defImage}` : newStudent.image}
                      width={100}
                      roundedCircle
                      className="m-3"
                    />

                    <input
                      hidden
                      type="file"
                      ref={uploader}
                      onChange={handlePickImage}
                    />
                    <Button
                      size="tiny"
                      loading={loadImage}
                      primary={newStudent.image ? true : false}
                      onClick={showPicker}
                    >
                      <Icon name="camera" />
                      {!newStudent.image ? "Upload Image" : "Uploaded"}
                    </Button>
                  </Col>
                </Row>
              </Container>
              <Message
                content={errors.response.message}
                hidden={!errors.response.show}
                positive={errors.response.type === "success"}
                negative={errors.response.type === "error"}
              />
              <Form size="large" style={{ marginBottom: 30, marginTop: 30 }}>
                <Form.Input
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="First name"
                  error={errors.firstName}
                  onChange={(e) => {
                    setStudent({ ...newStudent, firstName: e.target.value });
                    setErrors({ ...errors, firstName: false });
                  }}
                />
                <Form.Input
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="Last name"
                  error={errors.lastName}
                  onChange={(e) => {
                    setStudent({ ...newStudent, lastName: e.target.value });
                    setErrors({ ...errors, lastName: false });
                  }}
                />
                <Form.Input
                  fluid
                  icon="calendar alternate"
                  iconPosition="left"
                  placeholder="Date of birth"
                  error={errors.dob}
                  onChange={(e) => {
                    setStudent({ ...newStudent, dob: e.target.value });
                    setErrors({ ...errors, dob: false });
                  }}
                  onFocus={() => setShowCal(true)}
                  value={
                    !newStudent.dob
                      ? ""
                      : `${new Date(newStudent.dob).getDate()}-${
                          new Date(newStudent.dob).getMonth() + 1
                        }-${new Date(newStudent.dob).getFullYear()}`
                  }
                />
                <Segment style={{ display: !showCal ? "none" : "block" }}>
                  <Calendar
                    date={new Date()}
                    dateDisplayFormat="DD-MM-YY"
                    onChange={handleDate}
                    showSelectionPreview={true}
                  />
                </Segment>
                <Form.Input
                  fluid
                  icon="map marker alternate"
                  iconPosition="left"
                  placeholder="Address"
                  error={errors.address}
                  onChange={(e) => {
                    setStudent({ ...newStudent, address: e.target.value });
                    setErrors({ ...errors, address: false });
                  }}
                />
                <Dropdown
                  placeholder={"Select student level"}
                  selection
                  search
                  fluid
                  options={options}
                  error={errors.level}
                  onChange={(e) => {
                    setStudent({ ...newStudent, level: e.target.textContent });
                    setErrors({ ...errors, level: false });
                  }}
                />
              </Form>
              <Modal.Actions>
                <Button
                  negative
                  content="Cancel"
                  icon="close"
                  labelPosition="right"
                  onClick={() => setShowModal(false)}
                />
                <Button
                  content="Add Student"
                  labelPosition="right"
                  icon="checkmark"
                  loading={loading}
                  onClick={handleAddStudent}
                  primary
                />
              </Modal.Actions>
            </Modal.Content>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}

export default StudentForm;
